import axios from "axios";
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  availableAssessments: "available",
  startAssessment: (assessmentId) => `${assessmentId}/start`,
  getQuestions: (submissionId) => `${submissionId}/questions`,
  submitAnswers: "submit",
  getSubmissionResult: (submissionId) => `submission/${submissionId}/result`,
  getMyResults: "my-reports",
};

export const createAssessmentAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/assessments/" + endpoint + "/";
  const token = sessionStorage.getItem("token");
  return {
    fetch: () =>
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    fetchWithParams: (params) =>
      axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: params,
      }),
    post: (newRecord) => axios.post(url, newRecord),

    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    putWithToken: (updatedRecord) =>
      axios.put(url, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};
